import React from 'react';
import styled, { css } from 'styled-components';
import Tooltip from '@commoncomponents/frontend-components/dist/components/Tooltip';
import { IconHelp } from '@commoncomponents/frontend-components/dist/components/Icons/Icons';
import { theme } from '../../styled';
export const StandardLabelWrapper = styled.label `
  margin-bottom: 5px;
  display: flex;

  & > span {
    margin-right: 5px;
  }

  ${(props) => props.required &&
    css `
      &::before {
        content: '* ';
        color: ${theme.red};
      }
    `};
`;
const StandardLabel = ({ text, required = false, labelProps, className = '', tooltip, id, }) => (React.createElement(StandardLabelWrapper, Object.assign({ id: id, className: `standard-label ${className}`, required: required }, labelProps),
    text,
    tooltip && (React.createElement(Tooltip, { preferredPlacement: "right", theme: "dark", message: tooltip },
        React.createElement(IconHelp, { color: "#29333d", height: "14", width: "14" })))));
export default StandardLabel;
